import { call, METHODS } from "./ApiProvider";

const login = async (values) => {
    return await call(`/auth/login`, METHODS.POST, null, values);
};

const AuthService = {
    login
};

export default AuthService;